<div class="scope-row-header flex items-center">
  <div class="column level-{{ level }} {{ config?.componentMainColumnClass }}">
    <span isEllipsisActive>Department name</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.scopeVersion.isScopeByScenario()"></div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.QUANTITY?.selected"></div>
  <div
    class="column one--column"
    [hidden]="!isPreferenceActive(config?.userColumns.START_DATE)"></div>
  <div
    class="column one--column"
    [hidden]="!isPreferenceActive(config?.userColumns.END_DATE)"></div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.MARK_UP?.selected"></div>
  <div class="column one--column"></div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.SCOPEMARK_HOURS?.selected">
    <span isEllipsisActive>{{ 'scope_mark' | lang }}<br />hours</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.SCOPEMARK_PRICE?.selected">
    <span isEllipsisActive>{{ 'scope_mark' | lang }}<br />price</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.AGENCY_HOURS?.selected">
    <span isEllipsisActive>{{ 'agency|p' | lang }}<br />hours</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.scopeVersion.isScopeByScenario()"></div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.AGENCY_PRICE?.selected"
    *ngIf="!config?.scopeVersion.identity.costPlus">
    <span isEllipsisActive>{{ 'agency|p' | lang }}<br />price</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.AGENCY_PRICE?.selected"
    *ngIf="config?.scopeVersion.identity.costPlus">
    <span isEllipsisActive>Cost plus<br />price</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.showActionsColumn"></div>
</div>
